module.exports = __webpack_public_path__ + "static/img/portia.b7b5f48e.png";